// extracted by mini-css-extract-plugin
module.exports = {"licenseValidation":"styles_licenseValidation__1IUJf","loadingMessage":"styles_loadingMessage__VP85W"};